import { Dispatch, SetStateAction, useState } from 'react';
import { useGetCompoundVehiclesExportMutation } from '../../../api/compoundManagementApi';
import { CompoundVehicleType } from '../../../sharedComponents/common.types';
import { LocationFilter } from '../../../sharedComponents/filter/LocationFilter';
import { ExportModal } from '../../../sharedComponents/export/ExportModal';
import { CategoryFilter } from '../../../sharedComponents/export/CategoryFilter';

const FALL_BACK_FILE_NAME = 'compound-vehicles-export.xlsx';

export type CompoundVehiclesExportFilters = {
    location?: string;
    compoundVehicleTypes: CompoundVehicleType[];
};

export const DEFAULT_FILTERS: CompoundVehiclesExportFilters = {
    location: undefined,
    compoundVehicleTypes: [
        CompoundVehicleType.INCOMING,
        CompoundVehicleType.IN_INVENTORY,
        CompoundVehicleType.OUTGOING,
    ],
};

export const CompoundVehiclesExportModal = () => {
    const [localFilters, setLocalFilters] = useState(DEFAULT_FILTERS);
    const [getExcel] = useGetCompoundVehiclesExportMutation();

    const resetFilters = () => setLocalFilters(DEFAULT_FILTERS);

    return (
        <>
            <ExportModal
                tooltip="outboundOrderBook.compoundVehicles.export.tooltip"
                modalTitle="outboundOrderBook.compoundVehicles.export.title"
                filename={FALL_BACK_FILE_NAME}
                getExport={() =>
                    getExcel({
                        location: localFilters.location,
                        compoundVehicleTypes: localFilters.compoundVehicleTypes,
                    })
                }
                body={
                    <CompoundVehiclesExportModalContent localFilters={localFilters} setLocalFilters={setLocalFilters} />
                }
                resetFilters={resetFilters}
                isDisabled={localFilters.compoundVehicleTypes.length === 0}
            />
        </>
    );
};

export const vehicleTypeCheckboxDefinition: { category: CompoundVehicleType; labelId: string }[] = [
    { category: CompoundVehicleType.INCOMING, labelId: 'outboundOrderBook.compoundManagement.toolbar.incoming' },
    { category: CompoundVehicleType.IN_INVENTORY, labelId: 'outboundOrderBook.compoundManagement.toolbar.inventory' },
    { category: CompoundVehicleType.OUTGOING, labelId: 'outboundOrderBook.compoundManagement.toolbar.outgoing' },
    { category: CompoundVehicleType.DEPARTED, labelId: 'outboundOrderBook.compoundManagement.toolbar.departed' },
];

type CompoundVehiclesExportModalContentProps = {
    localFilters: CompoundVehiclesExportFilters;
    setLocalFilters: Dispatch<SetStateAction<CompoundVehiclesExportFilters>>;
};

export const CompoundVehiclesExportModalContent = (props: CompoundVehiclesExportModalContentProps) => {
    const setVehicleTypes = (types: CompoundVehicleType[]) => {
        props.setLocalFilters((prevState) => ({
            ...prevState,
            compoundVehicleTypes: types,
        }));
    };

    return (
        <div className="margin-bottom-20">
            <CategoryFilter
                categories={props.localFilters.compoundVehicleTypes}
                categoryDefinition={vehicleTypeCheckboxDefinition}
                setCategories={setVehicleTypes}
            />
            <LocationFilter
                value={props.localFilters.location}
                onLocationChange={(location) => {
                    props.setLocalFilters((prevState) => ({ ...prevState, location }));
                }}
            />
        </div>
    );
};
